import React from 'react';
import marked from 'marked';
import DOMPurify from 'dompurify';

export default function Markdone(props) {
  const parsedText = DOMPurify.sanitize(marked(props.markdown));

  return <div dangerouslySetInnerHTML={{ __html: parsedText }} {...props}></div>;
}
